import * as db from '../db';

export async function getSystemContacts(): Promise<db.SystemContact[]> {
  // stub for web
  return [];
}
